export default __webpack_public_path__ + "static/media/elle2.a350823d.webp";